import { TableOfContentsItem } from "@/components/blog/TableOfContents";

export const novedadesIaMayo2026TableOfContents: TableOfContentsItem[] = [
  {
    id: "gpt-55",
    title: "GPT-5.5: el nuevo estándar de OpenAI",
    subItems: [
      { id: "que-aporta-gpt55", title: "Qué aporta frente a GPT-5" },
      { id: "gpt55-vs-claude", title: "GPT-5.5 vs Claude en código" }
    ]
  },
  {
    id: "apple-ios27",
    title: "Apple abre iOS 27 a Claude y Gemini",
    subItems: [
      { id: "como-funciona-ios27", title: "Cómo funciona la elección de modelo" },
      { id: "impacto-apple", title: "Impacto en el ecosistema Apple" }
    ]
  },
  {
    id: "gemini-evoluciona",
    title: "Gemini se reinventa: memoria portable e instrucciones",
    subItems: [
      { id: "memoria-portable", title: "Memoria portable entre IAs" },
      { id: "gemini-docs", title: "Instrucciones permanentes en Docs" }
    ]
  },
  {
    id: "que-significa",
    title: "Qué significa todo esto para tu negocio",
    subItems: [
      { id: "estrategia-empresas", title: "Estrategia recomendada para empresas" },
      { id: "seo-ia-2026", title: "Implicaciones para SEO y contenido" }
    ]
  }
];
